module.exports = __webpack_public_path__ + "img/about7.a4df5ac5.png";